import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export { default as Badge } from "./Badge.vue"

export const badgeVariants = cva(
  "inline-flex gap-1.5 items-center rounded-full border px-2 py-0 text-[11px] font-mono leading-none h-[22px] tracking-tight whitespace-nowrap transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 [&_.dot]:size-1.5 [&_.dot]:rounded-full [&_.dot]:bg-current",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        // Depot design tones — driven by token CSS variables
        muted:
          "bg-[color:var(--bg-sunk)] text-[color:var(--fg-muted)] border-[color:var(--depot-border)]",
        pos:
          "border-transparent text-[color:var(--pos)] bg-[color:var(--pos-soft)]",
        neg:
          "border-transparent text-[color:var(--neg)] bg-[color:var(--neg-soft)]",
        warn:
          "border-transparent text-[color:var(--warn)] bg-[color:var(--warn-soft)]",
        info:
          "border-transparent text-[color:var(--info)] bg-[color:var(--info-soft)]",
        accent:
          "border-transparent text-[color:var(--depot-accent)] bg-[color:var(--accent-soft)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
